import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { detectRegion } from '../utils/regionDetect';

const CurrencyContext = createContext();
const API = process.env.REACT_APP_BACKEND_URL;

const detectDefaultCurrency = () => {
  const region = detectRegion();
  return region === 'US' ? 'USD' : 'CAD';
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(() => {
    const saved = localStorage.getItem('preferredCurrency');
    return saved || detectDefaultCurrency();
  });
  const [exchangeRate, setExchangeRate] = useState(0.73);

  useEffect(() => {
    fetch(`${API}/api/settings/currency`)
      .then(r => r.json())
      .then(data => { if (data.cad_to_usd) setExchangeRate(data.cad_to_usd); })
      .catch(() => {});
  }, []);

  const setCurrency = useCallback((c) => {
    setCurrencyState(c);
    localStorage.setItem('preferredCurrency', c);
  }, []);

  const formatPrice = useCallback((cadAmount, opts = {}) => {
    if (cadAmount == null) return '';
    const { decimals = 2, showCurrency = true } = opts;
    const amount = currency === 'USD' ? cadAmount * exchangeRate : cadAmount;
    const formatted = amount.toLocaleString(currency === 'USD' ? 'en-US' : 'en-CA', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
    if (showCurrency) return `$${formatted} ${currency}`;
    return `$${formatted}`;
  }, [currency, exchangeRate]);

  const convertPrice = useCallback((cadAmount) => {
    if (cadAmount == null) return 0;
    return currency === 'USD' ? cadAmount * exchangeRate : cadAmount;
  }, [currency, exchangeRate]);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, formatPrice, convertPrice, exchangeRate }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error('useCurrency must be used within CurrencyProvider');
  return ctx;
};
